
import { defineComponent, ref, computed } from "vue";
import ViewHeader from "@/components/ViewHeader.vue";
import { useStore } from "@/store";
import { useRouter } from "vue-router";

export default defineComponent({
    components: {
        ViewHeader,
    },
    async setup() {
        const store = useStore();
        const router = useRouter();
        const clubId = computed(() => store.state.clubId);
        const club = store.state.businessClients.find(x => x.id == clubId.value) ?? null;
        return { club };
    },
});
